import { type DehydratedState, type QueryClient, dehydrate, hydrate } from '@tanstack/react-query';

import { type IQueryState } from '../IQueryState';

export class QueryState implements IQueryState {
  public static readonly key = 'queryState';

  public readonly queryClient: QueryClient;

  public constructor(queryClient: QueryClient) {
    this.queryClient = queryClient;
  }

  public hydrate(dehydratedState: unknown): void {
    hydrate(this.queryClient, dehydratedState);
  }

  public dehydrate(): DehydratedState {
    return dehydrate(this.queryClient);
  }
}
